import React from 'react';
import './Featuring.css';
import { Link } from 'react-router-dom';
import OrderNowButton from './OrderNowButton';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import ShoppingBagIcon from '@mui/icons-material/ShoppingBag';
import HomeIcon from '@mui/icons-material/Home';
import RestaurantIcon from '@mui/icons-material/Restaurant';
import PhoneIcon from '@mui/icons-material/Phone';

const Featuring = () => {
  const features = [
    { 
      icon: <LocalShippingIcon />, 
      title: 'Delivery', 
      description: 'Straight to your door',
      action: <OrderNowButton theme="dark" />
    },
    { 
      icon: <ShoppingBagIcon />, 
      title: 'Takeout', 
      description: 'Quick and easy pickup' 
    },
    { 
      icon: <HomeIcon />, 
      title: 'Catering', 
      description: 'For special events' 
    },
    { 
      icon: <RestaurantIcon />, 
      title: 'Dine In', 
      description: 'Experience the ambiance' 
    },
    { 
      icon: <PhoneIcon />, 
      title: 'Reservations', 
      description: 'Book your table',
      action: (
        <Link to="/reservations" className="feature-button">
          Make a Reservation
        </Link>
      )
    },
  ];

  return (
    <section className="featuring-section">
      <div className="featuring-container">
        <h2>Featuring</h2>
        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-item">
              <div className="feature-icon">
                {feature.icon}
              </div>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
              {feature.action && (
                <div className="feature-action">
                  {feature.action}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Featuring; 